/**
 * TDF Ribbon Handler
 * Handles product cards with tdf_ribbon_span elements by copying their values
 * to .price-item--last elements and hiding the original ribbon spans
 */

class TDFRibbonHandler {
  constructor() {
    this.init();
  }

  init() {
    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.processProductCards();
        // Process again after a short delay for recently viewed and other dynamic content
        setTimeout(() => this.processProductCards(), 500);
        setTimeout(() => this.processProductCards(), 1000);
        setTimeout(() => this.processProductCards(), 2000);
      });
    } else {
      this.processProductCards();
      // Process again after a short delay for recently viewed and other dynamic content
      setTimeout(() => this.processProductCards(), 500);
      setTimeout(() => this.processProductCards(), 1000);
      setTimeout(() => this.processProductCards(), 2000);
    }

    // Watch for dynamically added content (e.g., AJAX loaded product cards)
    this.observeMutations();
  }

  processProductCards() {
    // Find all product cards that contain tdf_ribbon_span elements
    const ribbonSpans = document.querySelectorAll('.tdf_ribbon_span');
    
    ribbonSpans.forEach(ribbonSpan => {
      this.processRibbonSpan(ribbonSpan);
    });
  }

  processRibbonSpan(ribbonSpan) {
    try {
      // Skip if already processed
      if (ribbonSpan.classList.contains('tdf-ribbon-hidden')) {
        return;
      }

      // Get the text content from the ribbon span
      let ribbonText = ribbonSpan.textContent.trim();
      
      if (!ribbonText) {
        return; // Skip if no text content
      }

      // Remove "Now " from the beginning of the text if it exists
      ribbonText = ribbonText.replace(/^Now\s+/i, '');

      // Find the closest product card container - expanded list of potential parents
      const productCard = ribbonSpan.closest('.card-wrapper, .product-card-wrapper, .card, .swiper-slide, .product-item, [class*="product"]');
      
      if (!productCard) {
        console.warn('TDF Ribbon Handler: Could not find product card container for ribbon span');
        return;
      }

      // Find all .price-item--last elements within this product card (standard Shopify cards)
      const priceItems = productCard.querySelectorAll('.price-item--last');
      
      // Also find custom price elements used in recently viewed (EXP-RecentProduct)
      const customPriceElements = productCard.querySelectorAll('.harga span:not(.line-through):not(.hidden)');
      
      // Combine both types of price elements
      const allPriceElements = [...priceItems, ...customPriceElements];
      
      if (allPriceElements.length === 0) {
        console.warn('TDF Ribbon Handler: No price elements found in product card');
        return;
      }

      // Update each price element with the ribbon text
      allPriceElements.forEach(priceItem => {
        // Skip if already processed
        if (priceItem.classList.contains('tdf-ribbon-processed')) {
          return;
        }

        // Store original content if not already stored
        if (!priceItem.hasAttribute('data-original-content')) {
          priceItem.setAttribute('data-original-content', priceItem.innerHTML);
        }
        
        // Replace content with processed ribbon text
        priceItem.innerHTML = ribbonText;
        
        // Add orange styling and processed class
        priceItem.classList.add('tdf-ribbon-processed');
        priceItem.style.color = '#ff5b00'; // Orange color like the other product
      });

      // Hide the original ribbon span
      ribbonSpan.style.display = 'none';
      
      // Mark the ribbon span as processed
      ribbonSpan.classList.add('tdf-ribbon-hidden');
      
      console.log(`TDF Ribbon Handler: Processed ribbon with text "${ribbonText}" (removed "Now" if present)`);
      
    } catch (error) {
      console.error('TDF Ribbon Handler: Error processing ribbon span', error);
    }
  }

  observeMutations() {
    // Create a MutationObserver to watch for dynamically added content
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any added nodes contain ribbon spans
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.querySelector && node.querySelector('.tdf_ribbon_span')) {
                shouldProcess = true;
              }
            }
          });
        }
      });
      
      if (shouldProcess) {
        // Debounce the processing to avoid excessive calls
        clearTimeout(this.processTimeout);
        this.processTimeout = setTimeout(() => {
          this.processProductCards();
        }, 100);
      }
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Method to restore original content (useful for debugging or reversing changes)
  restoreOriginalContent() {
    const processedElements = document.querySelectorAll('.price-item--last.tdf-ribbon-processed');
    processedElements.forEach(element => {
      const originalContent = element.getAttribute('data-original-content');
      if (originalContent) {
        element.innerHTML = originalContent;
        element.removeAttribute('data-original-content');
        element.classList.remove('tdf-ribbon-processed');
      }
    });

    // Show hidden ribbon spans
    const hiddenRibbons = document.querySelectorAll('.tdf_ribbon_span.tdf-ribbon-hidden');
    hiddenRibbons.forEach(ribbon => {
      ribbon.style.display = '';
      ribbon.classList.remove('tdf-ribbon-hidden');
    });
  }
}

// Initialize the handler
window.TDFRibbonHandler = new TDFRibbonHandler();

// Add debugging helper functions to window for testing
window.TDFRibbonDebug = {
  // Function to test with a sample element
  test: function() {
    console.log('TDF Ribbon Handler - Testing...');
    const ribbonSpans = document.querySelectorAll('.tdf_ribbon_span');
    console.log(`Found ${ribbonSpans.length} ribbon spans`);
    
    const priceItems = document.querySelectorAll('.price-item--last');
    console.log(`Found ${priceItems.length} price-item--last elements`);
    
    return {
      ribbonSpans: ribbonSpans.length,
      priceItems: priceItems.length
    };
  },
  
  // Function to restore original content
  restore: function() {
    window.TDFRibbonHandler.restoreOriginalContent();
    console.log('TDF Ribbon Handler - Restored original content');
  },
  
  // Function to manually trigger processing
  process: function() {
    window.TDFRibbonHandler.processProductCards();
    console.log('TDF Ribbon Handler - Manually triggered processing');
  }
};

console.log('TDF Ribbon Handler loaded successfully');
console.log('Use TDFRibbonDebug.test() to check for elements');
console.log('Use TDFRibbonDebug.process() to manually trigger processing');
console.log('Use TDFRibbonDebug.restore() to restore original content');